import { useContext } from 'react';
import { AuthContext, hasScope } from 'automation-ui-core/context/AuthContext';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import Scopes from 'automation-ui-management/constants/Scopes';
export const useShowNonMarketingStatus = flowObjectTypeId => {
  const authContext = useContext(AuthContext);
  const hasMarketableContactsScope = hasScope(authContext.user.scopes)(Scopes.MARKETABLE_CONTACTS_ACCESS);
  return hasMarketableContactsScope && flowObjectTypeId === CONTACT_ID;
};